import { FC } from "react";

import { LiveMapMobileGridStatusPanel } from "./live-map.mobile-grid-status-panel";
import { LiveMapMobileMapStatsPanel } from "./live-map.mobile-map-stats-panel";

export const LiveMapMobileStatLeftPanel: FC = () => (
  <>
    <LiveMapMobileGridStatusPanel />
    <LiveMapMobileMapStatsPanel />
  </>
);
